import Login from "./pages/Login";
import LoggedOut from "./pages/LoggedOut";
import Verify2FA from "./pages/Verify2FA";
import Setup2FA from "./pages/Setup2FA";
import MonthlyReportsPage from "./pages/MonthlyReports";
import InstantAnalyticsPage from "./pages/InstantAnalytics";
import EntriesPage from "./pages/Entries";
import SourcesPage from "./pages/Sources";
import ThemePicker from "./components/Other/ThemePicker";
import packageJson from '../package.json';
import React from "react";
import config from "./config";
import {Redirect} from "react-router-dom";

const instashellSetup = {
    applicationVersion: packageJson.version,
    unshelledRoutesArr: [
        {
            path: `${config.uiBaseUrl}/`,
            targetPageComponent: (props) => <Login/>
        },
        {
            path: `${config.uiBaseUrl}/verify2fa`,
            targetPageComponent: (props) => <Verify2FA location={props.location}/>
        },
        {
            path: `${config.uiBaseUrl}/setup2fa`,
            targetPageComponent: (props) => <Setup2FA location={props.location}/>
        },
        {
            path: `${config.uiBaseUrl}/loggedOut`,
            targetPageComponent: (props) => <LoggedOut/>
        }
    ],
    shelledRoutesArr: [
        {
            path: `${config.uiBaseUrl}/monthlyReports`,
            pageTitle: 'Monthly Reports',
            hasBackButton: false,
            targetPageComponent: (props) => <MonthlyReportsPage/>
        },
        {
            path: `${config.uiBaseUrl}/instantAnalytics`,
            pageTitle: 'Instant Analytics',
            hasBackButton: false,
            targetPageComponent: (props) => <InstantAnalyticsPage/>
        },
        {
            path: `${config.uiBaseUrl}/entries/:source_key/:source_name/:source_type_key`,
            pageTitle: 'Entries',
            hasBackButton: true,
            targetPageComponent: (props) => <EntriesPage sourceKey={props.match.params.source_key}
                                                         sourceName={props.match.params.source_name}
                                                         sourceTypeKey={props.match.params.source_type_key}/>
        },
        {
            path: `${config.uiBaseUrl}/sources/:source_type_key/:source_type_name`,
            pageTitle: 'Sources',
            hasBackButton: true,
            targetPageComponent: (props) => <SourcesPage sourceTypeKey={props.match.params.source_type_key}
                                                         sourceTypeName={props.match.params.source_type_name}/>
        }
    ],
    sidebarHeader: {
        titleLabel: 'Verdantime',
        titleFont: 'Cookie',
        titleSize: '40px'
    },
    sidebarItemsArr: [
        {type: 'link', label: 'Instant Analytics', path: `${config.uiBaseUrl}/instantAnalytics`},
        {type: 'link', label: 'Monthly Reports', path: `${config.uiBaseUrl}/monthlyReports`},
        {type: 'break'},
        {type: 'link', label: 'Bank Accounts', path: `${config.uiBaseUrl}/sources/BANK%20ACCOUNT/Bank%20Accounts`},
        {type: 'link', label: 'Currencies', path: `${config.uiBaseUrl}/sources/CURRENCY/Currencies`},
        {type: 'link', label: 'Real Estate', path: `${config.uiBaseUrl}/sources/REAL%20ESTATE/Real%20Estate`},
        {type: 'link', label: 'Receivables', path: `${config.uiBaseUrl}/sources/RECEIVABLE/Receivables`},
        {type: 'link', label: 'Stocks', path: `${config.uiBaseUrl}/sources/STOCK/Stocks`},
        {type: 'link', label: 'Vehicles', path: `${config.uiBaseUrl}/sources/VEHICLE/Vehicles`},
        {type: 'link', label: 'Liabilities', path: `${config.uiBaseUrl}/sources/LIABILITY/Liabilities`},
        {type: 'break'},
        {type: 'link', label: 'Logout', path: `${config.uiBaseUrl}/loggedOut`}
    ],
    footerItemsArr: [
        {
            title: "Modules",
            contents: [
                {type: 'link', label: 'Instant Analytics', path: `${config.uiBaseUrl}/instantAnalytics`},
                {type: 'link', label: 'Monthly Reports', path: `${config.uiBaseUrl}/monthlyReports`}
            ]
        },
        {
            title: "Source Types",
            contents: [
                {type: 'link', label: 'Bank Accounts', path: `${config.uiBaseUrl}/sources/BANK%20ACCOUNT/Bank%20Accounts`},
                {type: 'link', label: 'Currencies', path: `${config.uiBaseUrl}/sources/CURRENCY/Currencies`},
                {type: 'link', label: 'Real Estate', path: `${config.uiBaseUrl}/sources/REAL%20ESTATE/Real%20Estate`},
                {type: 'link', label: 'Receivables', path: `${config.uiBaseUrl}/sources/RECEIVABLE/Receivables`},
                {type: 'link', label: 'Stocks', path: `${config.uiBaseUrl}/sources/STOCK/Stocks`},
                {type: 'link', label: 'Vehicles', path: `${config.uiBaseUrl}/sources/VEHICLE/Vehicles`},
                {type: 'link', label: 'Liabilities', path: `${config.uiBaseUrl}/sources/LIABILITY/Liabilities`},
            ]
        },
        {
            title: "Theme",
            contents: [
                {type: 'component', component: <ThemePicker label={'Light'} value={'light'}/>},
                {type: 'component', component: <ThemePicker label={'Dark'} value={'dark'}/>},
                {type: 'component', component: <ThemePicker label={'Blue'} value={'blue'}/>},
                {type: 'component', component: <ThemePicker label={'Pink'} value={'pink'}/>},
            ]
        }
    ]
}

export default instashellSetup;
